module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('div', {
    staticClass: "title"
  }, [_vm._v(" 企业用户登录 ")]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-box m-b-5",
    class: {
      error: !!_vm.errorText
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.phone),
      expression: "phone"
    }],
    staticClass: "text-center",
    attrs: {
      "type": "text",
      "placeholder": "请输入您的手机号"
    },
    domProps: {
      "value": (_vm.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.phone = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "error m-b-35"
  }, [_vm._v(_vm._s(_vm.errorText))]), _vm._v(" "), _c('div', {
    staticClass: "primary-btn m-b-14",
    on: {
      "click": _vm.checkLogin
    }
  }, [_vm._v("立即登录/注册")]), _vm._v(" "), _c('div', {
    staticClass: "button green-btn flex flex-center",
    on: {
      "click": _vm.goWx
    }
  }, [_c('img', {
    attrs: {
      "src": require('../../assets/images/wx_icon.png')
    }
  }), _vm._v("\n            微信快捷登录\n        ")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-88728210","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/login/login.vue
// module id = 901
// module chunks = 1